"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden lg:flex gap-1">
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted-light-background animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <Button variant="ghost" size="icon" className="lg:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-base font-medium transition-all duration-[var(--duration-medium)] hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-0 after:left-1/2 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:-translate-x-1/2 hover:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b border-border shadow-medium lg:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block px-4 py-3 text-base font-medium rounded-md hover:bg-muted-light-background transition-colors duration-[var(--duration-fast)]" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-medium)] ${scrolled ? "py-3 bg-white/80 backdrop-blur-md shadow-soft" : "py-5 bg-white"} border-b border-border`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-6">
          <Link to="/" className="flex-shrink-0 hover:opacity-80 transition-opacity duration-[var(--duration-fast)]">
            <img src="https://abawithpassion.com/wp-content/uploads/2026/02/aba_with_passion_logo.png" alt="ABA With Passion Inc" className="h-7" />
          </Link>

          <div className="flex-1 flex justify-center">
            <MenuProvider menu_id="28">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>

          <Button asChild className="flex-shrink-0 hover:scale-[1.02] active:scale-[0.98] transition-transform duration-[var(--duration-fast)] hover:!bg-primary-hover focus:!bg-primary-active">
            <Link to="tel:(305) 123-4567">Call Us</Link>
          </Button>
        </div>
      </div>
    </header>;
}